// @ts-nocheck
/* eslint-disable */
import { v4 as uuidv4 } from 'uuid';
import { CONFIG } from "~/config";

Mapy.Util = {};
Mapy.Util.HEX_TO_DEC = {
	"0": 0,
	"1": 1,
	"2": 2,
	"3": 3,
	"4": 4,
	"5": 5,
	"6": 6,
	"7": 7,
	"8": 8,
	"9": 9,
	"a": 10,
	"b": 11,
	"c": 12,
	"d": 13,
	"e": 14,
	"f": 15
};

Mapy.Util.createContextMenuItem = (function() {
	var contextMenuItem = function(label, clickCb) {
		SMap.Control.ContextMenu.Item.call(this, label);
		this._clickCb = clickCb;
	};

	contextMenuItem.prototype = Object.create(Object.assign({}, SMap.Control.ContextMenu.Item.prototype));

	contextMenuItem.prototype.click = function(e, menu) {
		if (this._disabled) { return; }
		if (typeof this._clickCb === "function") this._clickCb(e, menu);
	};

	return function(label = "", enabled = true, clickCb) {
		var cmi = new contextMenuItem(label, clickCb);

		if (enabled) {
			cmi.enable();
		}
		else {
			cmi.disable();
		}

		return cmi;
	};
})();

/**
 * Volani XML HTTP REQUESTU.
 *
 * @param {String} url Adresa endpointu bez ?
 * @param {Object} [opts] Volitelne parametry
 * @param {String} [opts.method] Metoda GET, POST, bere automaticky podle dat
 * @param {Object} [opts.get] Parametry pro GET
 * @param {Object} [opts.headers] Hlavicky pro poslani
 * @param {String} [opts.type] Typ pro odpoved
 * @param {Number} [opts.timeout] Timeout pro request
 * @param {Object} [opts.json] Data pro odeslani - JSON
 * @param {FormData} [opts.form] Data pro odeslani - FormData
 * @param {Object} [opts.post] Data pro odeslani - POST
 * @param {Object} [opts.data] Data pro odeslani - bez typu, muze byt cokoliv
 * @param {Object} [opts.noCredential = false] Neposilat pozadavek jako withCredential?
 */
 Mapy.Util.request = <T>(url, opts = {}): {
	request: XMLHttpRequest;
	promise: Promise<{
		data: T,
		error: any;
		status: number;
		request: XMLHttpRequest;
	}>;
} => {
	let request: XMLHttpRequest = null;
	let promise = new Promise((resolve, reject) => {
		if (!url || typeof url !== "string") {
			reject(new Error("No endpoint was set!"));
			return;
		}

		let method = opts.method || ((opts.post || opts.form || opts.json || opts.data) ? "POST" : "GET");

		if (opts.get) {
			url += "?" + (new URLSearchParams(opts.get)).toString();
		}

		// otevreni spojeni
		request = new XMLHttpRequest();
		request.open(method, url);

		// hlavicky
		for (let key in opts.headers) {
			request.setRequestHeader(key, opts.headers[key]);
		}

		const correlationId = uuidv4();

		if (!opts.noXHeaders) {
			request.setRequestHeader("X-Correlation-Id", correlationId);
		}

		// ab testy
		if (CONFIG.abTest && !opts.noABtest) {
			request.setRequestHeader("X-AB-Feature", CONFIG.abTest.flags);
		}

		if (opts.type && typeof opts.type === "string") {
			request.responseType = opts.type;
		}

		if (typeof opts.timeout === "number") {
			request.timeout = opts.timeout;
		}

		if (!opts.noCredential) {
			request.withCredentials = true;
		}

		let output = {
			data: null,
			error: null,
			status: 500,
			request
		};

		request.onload = () => {
			output.status = request.status;

			let responseType = request.getResponseHeader("Content-Type") || "";
			let responseData = request.responseType == "" || request.responseType == "text" ? request.responseText : (request.response || "");

			// parsovani dat
			try {
				if ((responseType.indexOf("application/json") != -1 && request.responseType != "json")) {
					output.data = responseData.length ? JSON.parse(responseData) : {};
				}
				else {
					output.data = responseData;
				}
			}
			catch (e) {
				output.error = e;
				reject(output);
			}

			// spravny status kod
			if (output.status >= 200 && output.status < 300) {
				resolve(output);
			}
			else {
				output.error = new Error(`Wrong status code ${output.status}`);
				reject(output);
			}
		};
		request.onerror = e => {
			output.status = request.status || 500;
			output.error = e;
			reject(output);
		};

		if (opts.json) {
			request.setRequestHeader("Content-type", "application/json");
			request.send(JSON.stringify(opts.json));
		}
		else if (opts.form) {
			let fd;

			if (opts.form instanceof FormData) {
				fd = opts.form;
			}
			else {
				fd = new FormData();
				Object.keys(opts.form).forEach(key => {
					fd.append(key, opts.form[key]);
				});
			}

			request.send(fd);
		}
		else if (opts.post) {
			request.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			request.send((new URLSearchParams(opts.post)).toString());
		}
		else if (opts.data) {
			request.send(opts.data);
		}
		else {
			request.send();
		}
	});

	return {
		request,
		promise
	};
};

Mapy.Util.isTouchDevice = () => "ontouchstart" in document.documentElement;

Mapy.Util.cloneObj = value => {
	switch (typeof value) {
		case "object":
			if (Array.isArray(value)) {
				// array
				let newArray = [];

				value.forEach(item => {
					newArray.push(Mapy.Util.cloneObj(item));
				});

				return newArray;
			}
			else if (value && value instanceof Date) {
				// date
				return new Date(value.getTime());
			}
			else if (value && value instanceof Element) {
				// element
				return value;
			}
			else if (value) {
				// object
				let newObj = {};

				Object.keys(value).forEach(prop => {
					if (value.hasOwnProperty(prop)) {
						newObj[prop] = Mapy.Util.cloneObj(value[prop]);
					}
				});

				return newObj;
			}
			else {
				// null
				return null;
			}

		case "undefined":
		case "boolean":
		case "function":
		case "number":
		case "string":
			return value;
	}
};

Mapy.Util.getObjValue = (obj, path, defValue) => {
	if (!obj && !path) {
		return null;
	}

	let curObj = obj;
	let parts = path.split(".");

	parts.every(part => {
		part = part.trim();

		let arrayMatch = part.match(/\[\s*(\d+)\s*\]/);
		let isOk = false;

		if (arrayMatch) {
			let arrayObj = curObj[part.replace(arrayMatch[0], "")];
			let ind = parseFloat(arrayMatch[1]);

			if (Array.isArray(arrayObj) && ind >= 0 && ind < arrayObj.length) {
				curObj = arrayObj[ind];
				isOk = true;
			}
		}
		else if (curObj && typeof curObj === "object" && !Array.isArray(curObj)) {
			curObj = curObj[part];
			isOk = true;
		}

		if (!isOk || typeof curObj === "undefined") {
			curObj = defValue || null;

			return false;
		}
		else {
			return true;
		}
	});

	return curObj;
};

Mapy.Util.loadScript = (function () {
	const loadedScripts = {};

	return function(src, crossorigin = false) {
		if (!(src in loadedScripts)) {
			const scriptPromise = new Promise(function(resolve, reject) {
				const script = document.createElement("script");

				script.type = "text/javascript";
				script.async = true;
				script.addEventListener("load", function() {
					resolve();
				});
				script.addEventListener("error", function() {
					// pri neuspechu odmazeme, aby mel volajici sanci to zopakovat
					delete loadedScripts[src];
					reject();
				});

				if (crossorigin) {
					script.setAttribute("crossorigin", "anonymous");
				}

				script.src = `${location.origin}${src}?${CONFIG.jsCompress ? CONFIG.filesVersion : Math.random()}`;
				document.head.appendChild(script);
			});

			loadedScripts[src] = scriptPromise;
		}

		return loadedScripts[src];
	};
})();

/**
 * Promichani poradi elementu v poli.
 *
 * @param {Array} array Vstupni pole
 */
Mapy.Util.shuffleArray = array => {
	return array
		.map(i => ({
			sort: Math.random(),
			value: i
		}))
		.sort((a, b) => a.sort - b.sort)
		.map(i => i.value);
};
